import { useEffect } from 'react';
import { Outlet } from 'react-router';
import Header from './Header';
import { useSeasonStore } from '../../stores/seasonStore';

export default function Layout() {
  const { fetchSeasonStatus, updateTimeRemaining, phaseEndTime } = useSeasonStore();

  // Fetch season status on mount
  useEffect(() => {
    fetchSeasonStatus();
  }, [fetchSeasonStatus]);

  // Poll season status every 30 seconds
  useEffect(() => {
    const interval = setInterval(fetchSeasonStatus, 30000);
    return () => clearInterval(interval);
  }, [fetchSeasonStatus]);

  // Update countdown timer every second when we have phase end time
  useEffect(() => {
    if (!phaseEndTime) return;

    updateTimeRemaining();
    const interval = setInterval(updateTimeRemaining, 1000);
    return () => clearInterval(interval);
  }, [phaseEndTime, updateTimeRemaining]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#fafafa]">
      <Header />
      <main className="pt-16">
        <Outlet />
      </main>
    </div>
  );
}
